// extracted by mini-css-extract-plugin
export var dataCell = "_q1-2";
export var dataRow = "_q1-0";
export var headerRow = "_q1-1";